var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.087 3.087a.583.583 0 0 1 .825 0L7 6.175l3.087-3.088a.583.583 0 1 1 .825.825L7.825 7l3.087 3.087a.583.583 0 1 1-.825.825L7 7.825l-3.088 3.087a.583.583 0 0 1-.825-.825L6.175 7 3.087 3.912a.583.583 0 0 1 0-.825",
  clipRule: "evenodd"
})));
export default SvgClose2;